/*============================================================
  Customer login: toggle between the sign-in form and the
  "recover password" form. Vanilla JS, no dependencies.
  The login form is visible by default in the markup, so the
  page still works if this script fails to load.
============================================================*/
(function () {
  const SELECTORS = {
    form: '[data-account-form]',
    showReset: '[data-show-reset]',
    hideReset: '[data-hide-reset]',
    recover: '[data-recover-password]',
    login: '[data-login-form]',
    recoverSuccess: '[data-recover-success]',
    recoverSuccessText: '[data-recover-success-text]',
  };
  const HIDDEN = 'is-hidden';
  const RECOVER_HASH = '#recover';

  function init() {
    const form = document.querySelector(SELECTORS.form);

    if (form) {
      const showButton = form.querySelector(SELECTORS.showReset);
      const hideButton = form.querySelector(SELECTORS.hideReset);
      const recover = form.querySelector(SELECTORS.recover);
      const login = form.querySelector(SELECTORS.login);
      const success = form.querySelector(SELECTORS.recoverSuccess);
      const successText = form.querySelector(SELECTORS.recoverSuccessText);

      // Recover-password toggle only applies on the login page.
      if (recover && login) {
        const showRecover = function () {
          recover.classList.remove(HIDDEN);
          login.classList.add(HIDDEN);
          window.location.hash = RECOVER_HASH;
        };

        const hideRecover = function () {
          login.classList.remove(HIDDEN);
          recover.classList.add(HIDDEN);
          history.replaceState(null, '', window.location.pathname + window.location.search);
        };

        if (window.location.hash === RECOVER_HASH || success) {
          showRecover();
        } else {
          hideRecover();
        }

        if (success && successText) {
          successText.classList.remove(HIDDEN);
        }

        if (showButton) {
          showButton.addEventListener('click', function (e) {
            e.preventDefault();
            showRecover();
          });
        }

        if (hideButton) {
          hideButton.addEventListener('click', function (e) {
            e.preventDefault();
            hideRecover();
          });
        }
      }
    }

    // Password show/hide works on both login and register pages.
    initPasswordToggles(document);

    // Offset the auth section below the fixed site header (the theme's
    // header-height variable isn't set on customer pages, so the static
    // MainContent padding is too small and the image overlaps the header).
    setAuthHeaderOffset();
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setAuthHeaderOffset, 150);
    });
    window.addEventListener('load', setAuthHeaderOffset);
  }

  function setAuthHeaderOffset() {
    const section = document.querySelector('.page-customer.cl');
    if (!section) return;
    const header = document.querySelector('header');
    if (!header) return;
    const main = document.getElementById('MainContent');
    const headerHeight = header.getBoundingClientRect().height;
    const mainPad = main ? parseFloat(getComputedStyle(main).paddingTop) || 0 : 0;
    const extra = Math.max(0, Math.round(headerHeight - mainPad));
    section.style.paddingTop = extra + 'px';
    // Expose header height + MainContent padding so the section can size to
    // exactly one viewport fold (form/image fill, trust bar pinned at bottom).
    section.style.setProperty('--cl-header', Math.round(headerHeight) + 'px');
    section.style.setProperty('--cl-mainpad', Math.round(mainPad) + 'px');
  }

  // Show/hide password fields via the eye toggle button(s).
  function initPasswordToggles(scope) {
    const toggles = scope.querySelectorAll('[data-password-toggle]');
    toggles.forEach(function (toggle) {
      const input = document.getElementById(toggle.getAttribute('data-password-toggle'));
      if (!input) return;
      const eyeOn = toggle.querySelector('.cl__eye--on');
      const eyeOff = toggle.querySelector('.cl__eye--off');

      toggle.addEventListener('click', function () {
        const show = input.type === 'password';
        input.type = show ? 'text' : 'password';
        toggle.setAttribute('aria-pressed', show ? 'true' : 'false');
        toggle.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
        if (eyeOn && eyeOff) {
          eyeOn.style.display = show ? '' : 'none';
          eyeOff.style.display = show ? 'none' : '';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
